module.exports = __webpack_public_path__ + "static/img/icon_id.6341011e.svg";